import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLoyaltyRewards, getLoyaltyProgram } from '../../services/api';

export const fetchLoyaltyRewards = createAsyncThunk(
    'loyaltyRewards/fetchRewards',
    async ({ perPage, page,created_by,status,keyword  }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyRewards(perPage, page,created_by,status,keyword );
            const data = response.data;
            return {
                rewards: data.data || data,
                totalPages: data.last_page,
            };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

export const fetchLoyaltyProgramsForRewards = createAsyncThunk(
    'loyaltyRewards/fetchPrograms',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyProgram();
            const data = response.data;
            return data.data || data;
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty program');
        }
    }
);

const loyaltyRewardsSlice = createSlice({
    name: 'loyaltyRewards',
    initialState: {
        rewards: [],
        programs: [],
        loading: true,
        error: '',
        totalPages: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLoyaltyRewards.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchLoyaltyRewards.fulfilled, (state, action) => {
                state.rewards = action.payload.rewards;
                state.totalPages = action.payload.totalPages;
                state.loading = false;
            })
            .addCase(fetchLoyaltyRewards.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            })
            .addCase(fetchLoyaltyProgramsForRewards.fulfilled, (state, action) => {
                state.programs = action.payload;
            })
            .addCase(fetchLoyaltyProgramsForRewards.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

export default loyaltyRewardsSlice.reducer;
